module.exports = __webpack_public_path__ + "static/img/triad.f1350c5b.png";